import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Clock, User } from 'lucide-react';
import { ResponsiveImage } from '../components/ResponsiveImage';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://motoring-daily.onrender.com';

export const NewsPage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/articles?category=News`);
      setArticles(data);
    } catch (error) {
      console.error('Error fetching news:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl font-heading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8F9FA] py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-black mb-4 font-heading">
            Latest News
          </h1>
          <p className="text-lg leading-relaxed text-[#666666]">
            Stay updated with the latest automotive news and industry insights.
          </p>
        </div>

        <div className="space-y-8">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-white border border-[#E5E7EB] rounded-sm overflow-hidden group hover:-translate-y-1 hover:shadow-xl transition-all duration-300 flex flex-col sm:flex-row"
              data-testid="news-article-card"
            >
              <div className="relative w-full sm:w-96 h-64 sm:h-auto overflow-hidden">
                <ResponsiveImage
                  src={article.image_url}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  width={900}
                  quality={72}
                />
                <span className="absolute top-4 left-4 bg-[#00A859] text-white text-xs font-bold uppercase tracking-wider py-1 px-3">
                  {article.category}
                </span>
              </div>
              <div className="p-6 flex-1">
                <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-3 font-heading">
                  {article.title}
                </h2>
                <p className="text-base leading-relaxed text-[#666666] mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center space-x-4 text-sm text-[#666666]">
                  <span className="flex items-center">
                    <User className="w-4 h-4 mr-1" />
                    {article.author}
                  </span>
                  <span className="flex items-center">
                    <Clock className="w-4 h-4 mr-1" />
                    {article.read_time} min read
                  </span>
                  <span>{new Date(article.created_at).toLocaleDateString()}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};